import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'

import '@/assets/icons/iconfont.css';//引入iconfont图标

import '@/assets/css/common.css';//引入公共css
import '@/assets/css/SpecificationPanel.css';//引入查看规范面板css

createApp(App).use(store).use(router).use(ElementPlus,{locale:zhCn}).mount('#app')
